import { ToDoList } from './components/ToDoList';

export const App = () => {
  return (
    <div>
      <ToDoList />
    </div>
  );
};
